'use client';
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import DynamicScrollHeader from '@components/DynamicScrollHeader';
import WharfMobile from './WharfMobile';
import WharfDesktop from './WharfDesktop';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';
export default function WharfHeader(props: any) {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  const mobileNav = props?.locale?.section?.ransomNavigationMobile?.[0] ?? [];
  const desktopNav = props?.locale?.section?.ransomNavigationDesktopNew ?? {
    left: [],
    right: [],
  };

  const mobileLogo = {
    src: props?.images?.ransome_wharf_logo_dark?.src || '',
    alt: props?.images?.ransome_wharf_logo_dark?.alt || 'Ransome Wharf Logo',
    url: '/',
  };
  if (!hasMounted) {
    return <div className={cn.wharfHeaderWrapper} style={{ height: '80px' }} />;
  }
  return (
    <DynamicScrollHeader
      headerClassName={cn.wharfHeaderWrapper}
      scrolledClassName={cn.wharfHeaderScroll}
    >
      <Box className={cn.wharfHeaderBlock}>
        <Mobile>
          <WharfMobile
            navData={{
              item: mobileNav,
              logo: mobileLogo,
            }}
          />
        </Mobile>
        <Desktop>
          <WharfDesktop navData={desktopNav} />
        </Desktop>
      </Box>
    </DynamicScrollHeader>
  );
}
